/**
 * Click-to-load facade for video embeds pasted into rich-text content.
 *
 * Product descriptions frequently contain a raw YouTube iframe. Loading one
 * eagerly costs roughly 970KB of player JavaScript before the page settles,
 * and `loading="lazy"` alone does not prevent it: the lazy-load distance
 * threshold is generous enough on slow connections that the frame is fetched
 * during initial load anyway.
 *
 * The Liquid side rewrites `src` to `data-deferred-embed`, so nothing is
 * requested until the visitor asks for it. This script paints a poster frame
 * and swaps the real iframe in on click.
 */
(function () {
  'use strict';

  var SELECTOR = 'iframe[data-deferred-embed]';

  function videoIdFrom(url) {
    var match = url.match(/\/embed\/([A-Za-z0-9_-]{6,})/);
    return match ? match[1] : null;
  }

  function build(iframe) {
    var url = iframe.getAttribute('data-deferred-embed');
    if (!url) return;

    var id = videoIdFrom(url);
    var facade = document.createElement('button');
    facade.type = 'button';
    facade.className = 'deferred-embed';
    facade.setAttribute('aria-label', iframe.getAttribute('title') || 'Play video');

    if (id) {
      facade.style.backgroundImage =
        "url('https://i.ytimg.com/vi/" + id + "/hqdefault.jpg')";
    }

    // Preserve the slot the iframe occupied so nothing shifts when it swaps in.
    var width = iframe.getAttribute('width');
    var height = iframe.getAttribute('height');
    if (width && height && String(width).indexOf('%') === -1) {
      facade.style.aspectRatio = width + ' / ' + height;
    }

    facade.innerHTML = '<span class="deferred-embed__play" aria-hidden="true"></span>';

    facade.addEventListener('click', function () {
      iframe.setAttribute('src', url + (url.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1');
      iframe.removeAttribute('data-deferred-embed');
      iframe.hidden = false;
      if (facade.parentNode) facade.parentNode.replaceChild(iframe, facade);
      iframe.focus();
    });

    iframe.hidden = true;
    if (iframe.parentNode) iframe.parentNode.insertBefore(facade, iframe);
  }

  function scan(root) {
    var frames = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < frames.length; i++) build(frames[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  // Tab panels and quick-view modals inject description markup after load.
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            if (added[j].matches && added[j].matches(SELECTOR)) build(added[j]);
            else scan(added[j]);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
